<template>
  <v-row>
    <ObjectPageHeaderMobile v-if="isObjectPage" />
    <PageHeaderMobile v-else />
    <MobileLeftMenu />
    <MobileRightMenu />
  </v-row>
</template>

<script>
import PageHeaderMobile from '@/components/App/Header/PageHeaderMobile'
import MobileLeftMenu from '@/components/App/Menu/MobileLeftMenu'
import MobileRightMenu from '@/components/App/Menu/MobileRightMenu'
import ObjectPageHeaderMobile from '@/components/App/Header/ObjectPageHeaderMobile'
import sharedComputed from '@/methods/sharedComputed'

export default {
  name: 'MobileTopPart',

  components: {
    ObjectPageHeaderMobile,
    MobileRightMenu,
    MobileLeftMenu,
    PageHeaderMobile,
  },

  computed: {
    ...sharedComputed,
  },
}
</script>
